import {
    SidebarGroup,
    SidebarGroupContent,
    SidebarMenu,
    SidebarMenuButton,
    SidebarMenuItem,
    SidebarMenuSub,
    SidebarMenuSubButton,
} from '@duck/ui'
import { Link } from '@tanstack/react-router'
import { Settings, LayoutDashboard, Users, CheckSquare, Target, Mail, Clock, Building2, BarChart3 } from 'lucide-react'
import { useTar } from '@/modules/i18n/useTar'

type SideBarAdminProps = {
    open: boolean
    handleMobileNav: () => void
}

export const SideBarAdmin = ({ open, handleMobileNav }: SideBarAdminProps) => {
    const { t } = useTar()

    return (
        <SidebarGroup>
            <SidebarGroupContent>
                <SidebarMenu>
                    <SidebarMenuItem>
                        {!open ? (
                            <SidebarMenuButton asChild>
                                <Link to="/admin" onClick={handleMobileNav}>
                                    <Settings />
                                    <span>{t('navigation.admin')}</span>
                                </Link>
                            </SidebarMenuButton>
                        ) : (
                            <>
                                <SidebarMenuButton asChild>
                                    <div className="pointer-events-none">
                                        <Settings />
                                        <span>{t('navigation.admin')}</span>
                                    </div>
                                </SidebarMenuButton>
                                <SidebarMenuSub>
                                    <SidebarMenuSubButton asChild>
                                        <Link to="/admin" onClick={handleMobileNav}>
                                            <LayoutDashboard />
                                            <span>{t('navigation.dashboard')}</span>
                                        </Link>
                                    </SidebarMenuSubButton>
                                    <SidebarMenuSubButton asChild>
                                        <Link to="/admin/statistics" onClick={handleMobileNav}>
                                            <BarChart3 />
                                            <span>{t('navigation.statistics')}</span>
                                        </Link>
                                    </SidebarMenuSubButton>
                                    <SidebarMenuSubButton asChild>
                                        <Link to="/admin/users" onClick={handleMobileNav}>
                                            <Users />
                                            <span>{t('navigation.users')}</span>
                                        </Link>
                                    </SidebarMenuSubButton>
                                    <SidebarMenuSubButton asChild>
                                        <Link to="/admin/tasks" onClick={handleMobileNav}>
                                            <CheckSquare />
                                            <span>{t('navigation.tasks')}</span>
                                        </Link>
                                    </SidebarMenuSubButton>
                                    <SidebarMenuSubButton asChild>
                                        <Link to="/admin/challenges" onClick={handleMobileNav}>
                                            <Target />
                                            <span>{t('navigation.challenges')}</span>
                                        </Link>
                                    </SidebarMenuSubButton>
                                    <SidebarMenuSubButton asChild>
                                        <Link to="/admin/invitations" onClick={handleMobileNav}>
                                            <Mail />
                                            <span>{t('navigation.invitations')}</span>
                                        </Link>
                                    </SidebarMenuSubButton>
                                    <SidebarMenuSubButton asChild>
                                        <Link to="/admin/waiting-list" onClick={handleMobileNav}>
                                            <Clock />
                                            <span>{t('navigation.waitingList')}</span>
                                        </Link>
                                    </SidebarMenuSubButton>
                                    <SidebarMenuSubButton asChild>
                                        <Link to="/admin/organizations" onClick={handleMobileNav}>
                                            <Building2 />
                                            <span>{t('navigation.organizations')}</span>
                                        </Link>
                                    </SidebarMenuSubButton>
                                    <SidebarMenuSubButton asChild>
                                        <Link to="/admin/settings" onClick={handleMobileNav}>
                                            <Settings />
                                            <span>{t('navigation.settings')}</span>
                                        </Link>
                                    </SidebarMenuSubButton>
                                </SidebarMenuSub>
                            </>
                        )}
                    </SidebarMenuItem>
                </SidebarMenu>
            </SidebarGroupContent>
        </SidebarGroup>
    )
}
